import { useContext } from "react";

import { ProjectWBSContext } from "@/shared/context/projectWBS/ProjectWBSContext";

const useProjectWBSContext = () => useContext(ProjectWBSContext);

export default useProjectWBSContext;
